/**
 * Configuration Category Banner
 *
 * Compact toggle switches illustration representing settings and configuration.
 * Designed as a standalone icon to accompany text in a merged header.
 */

import type { CategoryBannerProps } from './index';

export function ConfigurationBanner({
  width = 100,
  height = 100,
  className = '',
}: CategoryBannerProps) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Configuration settings illustration"
      style={{ maxWidth: '100%', height: 'auto' }}
    >
      <defs>
        <linearGradient id="configToggleOn" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#9d8de5" />
          <stop offset="100%" stopColor="#8b7bd8" />
        </linearGradient>
      </defs>

      {/* Subtle background circle */}
      <circle cx="50" cy="50" r="46" fill="#f5f3fb" />

      {/* Toggle 1 (on) */}
      <g transform="translate(28, 30)">
        <rect x="0" y="0" width="44" height="16" rx="8" fill="url(#configToggleOn)" />
        <circle cx="34" cy="8" r="6" fill="white" />
      </g>

      {/* Toggle 2 (off) */}
      <g transform="translate(28, 54)">
        <rect x="0" y="0" width="44" height="16" rx="8" fill="#d4ccf0" />
        <circle cx="10" cy="8" r="6" fill="white" />
      </g>
    </svg>
  );
}
